import React, { useState, useEffect } from 'react';
import { checkAuthError } from '../utils/sessionUtils';
import cofre112v2 from './images/cofre112v2.png';
import biruxBronce112 from './images/biruxBronce112.png';
import biruxComodin112 from './images/biruxComodin112.png';
import biruxPlata112 from './images/biruxPlata112.png';
import biruxOro112 from './images/biruxOro112.png';
import corazon64 from './images/corazon64.png';

const REWARD_IMAGES = {
    overbox: cofre112v2,
    birux: biruxBronce112,
    biruxComodin: biruxComodin112,
    biruxPlata: biruxPlata112,
    biruxOro: biruxOro112,
    vidas: corazon64,
};

const Missions = ({ handleAuth, missions, fetchMissions }) => {
    const [loading, setLoading] = useState(true);
    const [claiming, setClaiming] = useState(null);

    useEffect(() => {
        fetchMissions().then(data => {
            if (checkAuthError(data)) return;
            setLoading(false);
        });
    }, []);

    const handleClaim = async (missionId) => {
        if (claiming) return;
        setClaiming(missionId);
        try {
            const res = await fetch('/api/missions/claim', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ missionId }),
            });
            const data = await res.json();
            if (data.success) {
                await handleAuth(false);
                await fetchMissions();
            } else if (checkAuthError(data)) {
                return;
            }
        } catch (err) {
            console.error('Error claiming mission:', err);
        } finally {
            setClaiming(null);
        }
    };

    const getRewardLabel = (type) => {
        const labels = {
            overbox: 'Overbox',
            biruxComodin: 'Birux Comodin',
            birux: 'Birux',
            biruxPlata: 'Birux Plata',
            biruxOro: 'Birux Oro',
            vidas: 'Combates de la arena',
        };
        return labels[type] || type;
    };

    const getResetLabel = (type) => {
        const labels = {
            daily: 'Diaria',
            weekly: 'Semanal',
            permanent: 'Permanente',
        };
        return labels[type] || type;
    };

    const getStatusBadge = (mission) => {
        if (mission.claimed) return { text: 'Reclamada', className: 'missionBadgeClaimed' };
        if (mission.completed) return { text: 'Completada', className: 'missionBadgeCompleted' };
        if (mission.progress > 0) return { text: 'En progreso', className: 'missionBadgeProgress' };
        return { text: 'Disponible', className: 'missionBadgeAvailable' };
    };

    if (loading) {
        return <div className="core heroes"><p>Cargando misiones...</p></div>;
    }

    return (
        <div className="core heroes">
            <div className="flex marginTop"><h2>Misiones</h2></div>
            {missions.length === 0 ? (
                <p>No hay misiones activas en este momento.</p>
            ) : (
                <div className="missionsGrid">
                    {missions.map(mission => {
                        const progress = Math.min(mission.progress, mission.targetValue);
                        const percentage = mission.targetValue > 0 ? (progress / mission.targetValue) * 100 : 0;
                        const badge = getStatusBadge(mission);

                        return (
                            <div key={mission._id} className={'missionCard' + (mission.claimed ? ' missionClaimed' : '')}>
                                <span className={'missionBadge ' + badge.className}>{badge.text}</span>
                                <h3 className="missionName">{mission.name}</h3>
                                <p className="missionDesc">{mission.description}</p>
                                <div className="missionProgressWrap">
                                    <div className="missionProgressBar">
                                        <div
                                            className="missionProgressFill"
                                            style={{ width: percentage + '%' }}
                                        />
                                    </div>
                                    <span className="missionProgressText">{Math.round(percentage)}%</span>
                                </div>
                                <div className="missionFooter">
                                    <span className="missionReward">
                                        {mission.rewards.map(r => (
                                            <span key={r.type} className="missionRewardItem">
                                                +{r.amount}
                                                <img src={REWARD_IMAGES[r.type]} alt={getRewardLabel(r.type)} title={getRewardLabel(r.type)} />
                                            </span>
                                        ))}
                                    </span>
                                    <span className="missionReset">{getResetLabel(mission.resetType)}</span>
                                </div>
                                {mission.completed && !mission.claimed && (
                                    <div
                                        className={'btnForallia missionClaimBtn' + (claiming === mission._id ? ' disabled' : '')}
                                        onClick={() => handleClaim(mission._id)}
                                    >
                                        {claiming === mission._id ? 'Reclamando...' : 'Reclamar'}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default Missions;
